import React from 'react';
import NextLink from 'next/link';
import styles from './styles.module.scss';

type MyLinkProps = {
    href: string
    external?: boolean
    className?: string
    [key: string]: any
}

const MyLink = ({ external = false, className, ...props }: MyLinkProps) => {
  const linkClassName = [styles.link, className].filter(Boolean).join(' ');
  if (external == true) {
    return <a className={linkClassName} {...props} target="_blank" rel="noopener noreferrer" />;
  }
  return <NextLink className={linkClassName} {...props} />;
};

export default MyLink;
